import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".js-fv");
  if (!root) return;

  const titleSpans = root.querySelectorAll(".js-title span");
  const blurs = root.querySelector(".js-blurs");
  const header = document.querySelector("header");
  const scroll = root.querySelector(".js-scrolldown");

  // ------------------------
  // 初期状態をJSで固定（ズレ防止）
  // ------------------------
  gsap.set(titleSpans, {
    opacity: 0,
    y: 18,
    filter: "blur(10px)",
  });

  gsap.set(blurs, {
    opacity: 0,
    yPercent: 5,
    scale: 0.98,
  });

  gsap.set(header, {
    opacity: 0,
    y: -20,
  });

  gsap.set(scroll, {
    opacity: 0,
    y: -10,
  });

  // ------------------------
  // 初回アニメーション
  // ------------------------
  const tl = gsap.timeline({
    defaults: {
      ease: "power2.out",
    },
  });

  tl.to(titleSpans, {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 1.2,
    stagger: {
      each: 0.35,
      from: "start",
    },
    ease: "power3.out",
  })
    .to(
      blurs,
      {
        opacity: 1,
        yPercent: 0,
        scale: 1,
        duration: 1.2,
      },
      "-=0.6"
    )
    .to(
      header,
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
      },
      "-=0.3"
    )
    .to(scroll, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power2.out",
    });

  // ------------------------
  // ふよふよアニメーション（常時）
  // ------------------------
  const blurImages = root.querySelectorAll(".js-blurs img");

  blurImages.forEach((img, i) => {
    gsap.to(img, {
      x: () => gsap.utils.random(-100, 100),
      y: () => gsap.utils.random(-100, 100),
      duration: () => gsap.utils.random(2, 4),
      ease: "sine.inOut",
      repeat: -1,
      yoyo: true,
      delay: i * 0.2,
    });
  });
});